import DesignEditorPrimaryControlButton from './DesignEditorPrimaryControlButton';

export default DesignEditorPrimaryControlButton;
